(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('lead-offer', {
            parent: 'entity',
            url: '/lead-offer?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadOffer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-offer/lead-offers.html',
                    controller: 'LeadOfferController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadOffer');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('lead-offer-detail', {
            parent: 'entity',
            url: '/lead-offer/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadOffer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-offer/lead-offer-detail.html',
                    controller: 'LeadOfferDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadOffer');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'LeadOffer', function($stateParams, LeadOffer) {
                    return LeadOffer.get({id : $stateParams.id});
                }]
            }
        })
        .state('lead-offer.new', {
            parent: 'lead-offer',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-offer/lead-offer-dialog.html',
                    controller: 'LeadOfferDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstEstimationDate: null,
                                wantsTransportation: null,
                                attendantMeal: null,
                                hasCompetitiveBid: null,
                                openHospitalizationReference: null,
                                roomServices: null,
                                comments: null,
                                invitationText: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('lead-offer', null, { reload: true });
                }, function() {
                    $state.go('lead-offer');
                });
            }]
        })
        .state('lead-offer.edit', {
            parent: 'lead-offer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-offer/lead-offer-dialog.html',
                    controller: 'LeadOfferDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LeadOffer', function(LeadOffer) {
                            return LeadOffer.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-offer', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('lead-offer.delete', {
            parent: 'lead-offer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-offer/lead-offer-delete-dialog.html',
                    controller: 'LeadOfferDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LeadOffer', function(LeadOffer) {
                            return LeadOffer.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-offer', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
